import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const TrademarkRenewal = () => {
  const usps = [
    {
      title: 'Deadline Tracking & Reminders',
      description: 'Never worry about missing a renewal window again. We track every critical date—Section 8, Section 9, and Section 71 filings—and alert you well in advance.'
    },
    {
      title: 'Complete Document Preparation',
      description: 'From declarations of use to renewal applications, our team prepares and reviews every filing for accuracy, so your renewal moves through the USPTO without delays.'
    },
    {
      title: 'Specimen Review & Support',
      description: 'Submitting the right proof of use is essential. We evaluate your specimens against USPTO standards and help you gather acceptable evidence before filing.'
    },
    {
      title: 'Portfolio-Wide Management',
      description: 'Managing multiple marks across different renewal cycles? We centralize your entire trademark portfolio with a single dashboard and coordinated filing schedule.'
    }
  ];

  const whyChooseContent = {
    about: 'A registered trademark can last forever—but only if it is renewed on time with the proper filings. Missing a Section 8 or Section 9 deadline can result in cancellation, leaving your brand unprotected and your years of brand equity at risk.',
    intro: 'Trademark Vector keeps your registrations alive and enforceable, handling every renewal filing so you never lose the rights you worked hard to secure.',
    paragraph1: 'Our renewal specialists manage the entire process: calculating your deadlines, preparing declarations of use, reviewing specimens, and filing with the USPTO. You receive status updates at every stage, with zero paperwork headaches.',
    paragraph2: 'From first renewals to combined Section 8 and 15 filings, we tailor our service to your registration\'s exact requirements. Protect your investment with proactive renewal management that keeps your brand legally protected for decades to come.'
  };

  return (
    <ServiceTemplate
      title="Trademark Renewal"
      subtitle="Keep Your Trademark Active with Professional Renewal Services"
      description="Your trademark is more than a filing—it's your reputation, your identity, your legacy. One missed deadline can erase it all. Our renewal specialists guard every critical date, craft flawless Section 8, 9, and 15 filings, and keep your brand's legal shield stronger than ever."
      heroImage="https://images.unsplash.com/photo-1506784983877-45594efa4cbe"
      aboutImage="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800"
      serviceId="trademark-renewal"
      metaTitle="Trademark Renewal & USPTO Deadline Management | Trademark Vector"
      metaDescription="Never lose your registration. We track Section 8, 9 & 15 deadlines, prepare declarations of use & file error-free renewals to keep your mark active."
      usps={usps}
      whyChooseContent={whyChooseContent}
    />
  );
};

export default TrademarkRenewal;
